/* @flow */

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { translate } from '../../../../../react/features/base/i18n/functions';
import { XIconInfo } from '../../../../../react/features/base/icons/svg';
import ToolboxItem from '../../../../../react/features/base/toolbox/components/ToolboxItem';

/**
 * The type of the React {@code Component} state of
 * {@link LocalRecordingButton}.
 */
type Props = {

    /**
     * The redux store's {@code dispatch} function.
     */
    dispatch: Dispatch<any>,

    _isInfoEnabled: boolean,

    _isVisible: boolean,

    /**
     * Callback function called when {@link LocalRecordingButton} is clicked.
     */
    onClick: Function,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function
}

/**
 * A React {@code Component} for opening or closing the
 * {@code LocalRecordingInfoDialog}.
 *
 * @extends Component
 */
class InfoButton extends Component<Props> {

    /**
     * Initializes a new {@code LocalRecordingButton} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);

        // Bind event handlers so they are only bound once per instance.
        this._onClick = this._onClick.bind(this);
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _isVisible, _isInfoEnabled, t } = this.props;

        return (
            <div className={'button-circle button-info'} style = {{
                visibility: _isVisible ? 'visible' : 'hidden'
            }}>
                <ToolboxItem
                    accessibilityLabel = { t('xbees.info') }
                    icon = { XIconInfo }
                    tooltipPosition={'left'}
                    onClick = { this._onClick }
                    toggled = { _isInfoEnabled }
                    tooltip = { t('xbees.info') } />
            </div>
        );
    }

    _onClick: () => void;

    /**
     * Callback invoked when the Toolbar button is clicked.
     *
     * @private
     * @returns {void}
     */
    _onClick() {
        const { _isInfoEnabled } = this.props;

        APP.xBeesEvents.toggleInfo(_isInfoEnabled, true);

        document.activeElement.blur();
    }
}

function _mapStateToProps(state) {
    const { isInfoButtonVisible, isInfoEnabled } = state['xbees/buttons'];

    return {
        _isVisible: isInfoButtonVisible,
        _isInfoEnabled: isInfoEnabled
    };
}

export default translate(connect(_mapStateToProps, null)(InfoButton));
